import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from 'reflexbox'
import { useField } from 'formik'

import { CheckboxField } from 'components/Form'

import { Label, ErrorText } from './styles'

const CheckboxGroup = ({ label, name, direction, options, ...props }) => {
  const [field, meta] = useField(name)
  const isError = meta.touched && meta.error
  return (
    <Box {...props}>
      <Box mb='10px'>
        <Label error={isError}>{label}</Label>
      </Box>
      <Flex flexDirection={direction}>
        {options.map((option, index) => (
          <CheckboxField key={index} name={name} selectedValues={props.selectedValues} multiple {...option} />
        ))}
        {isError && <ErrorText>{meta.error}</ErrorText>}
      </Flex>
    </Box>
  )
}
CheckboxGroup.defaultProps = {
  direction: 'column',
}

CheckboxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  selectedValues: PropTypes.object,
  direction: PropTypes.oneOf(['row', 'column']),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  ...Box.propTypes,
}

export default CheckboxGroup
